document.querySelectorAll('button[aria-controls^="faq-"]').forEach(button => {
  button.addEventListener('click', () => {
    const dd = document.getElementById(button.getAttribute('aria-controls'));
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded
    button.setAttribute('aria-expanded', String(!isExpanded));

    // Toggle answer visibility
    dd.classList.toggle('hidden');

    // Toggle icons
    const icons = button.querySelectorAll('img[data-slot="icon"]');
    icons[0].classList.toggle('hidden'); // Plus icon
    icons[1].classList.toggle('hidden'); // Minus icon
  });
});